import { useFlashToast } from "@/hooks/useFlashToast"

/**
 * Component that shows toast notifications for flash messages.
 * Renders nothing but triggers toasts when flash messages change.
 * Added to page layouts via Inertia's resolve function.
 */
export function FlashToastHandler() {
  useFlashToast()
  return null
}
